export default __webpack_public_path__ + "static/media/3.08cbf626.jpg";